if (!customElements.get('emberhunt-product-page')) {
  customElements.define('emberhunt-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.observeBundle();
        this.observer?.observe(this.add);
        this.checkBundle();
        return;
      }
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-product-data]').textContent);
      this.variants = this.data.variants.filter(variant => variant.pairs === 1);
      this.form = this.querySelector('form');
      this.select = this.querySelector('[name="id"]');
      this.price = this.querySelector('[data-current-price]');
      this.unit = this.querySelector('[data-current-unit]');
      this.total = this.querySelector('[data-bundle-total]');
      this.error = this.querySelector('[data-error]');
      this.add = this.querySelector('[data-main-add]');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyAdd = this.querySelector('[data-sticky-add]');
      this.bundleAnchor = this.querySelector('[data-bundle-anchor]');
      this.bundleReady = false;
      this.offerQuantities = new Map(Object.entries(this.data.bundleQuantities || {}));
      this.boundWidgets = new WeakSet();
      this.querySelector('[data-enhanced-options]').hidden = false;
      this.querySelector('[data-native-options]').hidden = true;
      this.syncGallerySelection();
      this.update(false);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-index]')) this.update(true);
        if (this.bundleAnchor.contains(event.target)) this.queuePriceSync();
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-image]');
        if (thumb) {
          const hero = this.querySelector('[data-hero-image]');
          hero.src = thumb.dataset.galleryImage;
          hero.srcset = thumb.dataset.gallerySrcset || '';
          hero.alt = thumb.dataset.galleryAlt;
          this.syncGallerySelection();
        }
        if (this.bundleAnchor.contains(event.target)) this.queuePriceSync();
        if (event.target.closest('[data-jump], [data-sticky-add]')) {
          event.preventDefault();
          this.bundleAnchor.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
          this.bundleAnchor.focus({preventScroll:true});
        }
        if (event.target.closest('[data-size-link]')) {
          const sizes = document.getElementById('EhpSizeGuide');
          if (!sizes) return;
          event.preventDefault();
          sizes.open = true;
          sizes.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
          sizes.querySelector('summary').focus({preventScroll:true});
        }
      });
      this.form.addEventListener('submit', event => {
        if (!this.bundleReady || !this.current?.available) {
          event.preventDefault();
          this.error.textContent = this.data.labels.bundleError;
          this.error.focus();
        }
      });
      this.bundleObserver = new MutationObserver(() => this.checkBundle());
      this.observeBundle();
      this.bundleTimeout = setTimeout(() => {
        if (!this.bundleReady) this.error.textContent = this.data.labels.bundleError;
      },12000);
      this.checkBundle();
      this.observer = new IntersectionObserver(([entry]) => {
        this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold:0});
      this.observer.observe(this.add);
    }
    observeBundle() {
      this.bundleObserver?.observe(this.bundleAnchor,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','checked']});
    }
    checkBundle() {
      this.bundleReady = Boolean(this.bundleAnchor.querySelector('.kaching-bundles__bar-main'));
      if (this.bundleReady) {
        clearTimeout(this.bundleTimeout);
        this.error.textContent = '';
      }
      this.bundleAnchor.querySelectorAll('kaching-bundles-block').forEach(widget => {
        const deal = JSON.parse(widget.getAttribute('deal-block') || '{}');
        // Per-pair choices must not reselect the product's default bundle.
        if (deal.differentVariantsEnabled && deal.disableVariantOptionSync === false) {
          deal.disableVariantOptionSync = true;
          widget.setAttribute('deal-block',JSON.stringify(deal));
        }
        (deal.dealBars || []).forEach(bar => {
          const quantity = bar.dealBarType === 'bxgy' ? Number(bar.buyQuantity || 0) + Number(bar.getQuantity || 0) : Number(bar.quantity || 0);
          if (quantity > 0) this.offerQuantities.set(bar.id,quantity);
        });
        if (this.boundWidgets.has(widget)) return;
        this.boundWidgets.add(widget);
        this.syncBundleVariant();
        ['deal-bar-selected','variant-selected','variants-changed'].forEach(name => {
          widget.addEventListener(name, event => {
            const items = event.detail?.variantIdQuantities;
            if (Array.isArray(items)) {
              const quantity = items.reduce((sum,item) => sum + Number(item.quantity || 0),0);
              const selected = this.selectedBar();
              if (quantity > 0 && selected) this.offerQuantities.set(selected.dataset.dealBarId,quantity);
            }
            this.queuePriceSync();
          });
        });
      });
      this.normalizeBundlePickers();
      this.syncBundlePrice();
      this.updateBuyState();
    }
    normalizeBundlePickers() {
      // Each Kaching row represents one pair; old multi-pair variants are not bundle items.
      this.bundleAnchor.querySelectorAll('select[data-name="Pack"]').forEach(select => {
        const single = Array.from(select.options).find(option => option.value === '1 pair');
        if (!single) return;
        const changed = select.value !== single.value;
        Array.from(select.options).forEach(option => { if (option !== single) option.remove(); });
        select.value = single.value;
        select.hidden = true;
        if (changed) select.dispatchEvent(new Event('change',{bubbles:true}));
      });
      this.bundleAnchor.querySelectorAll('.kaching-bundles__bar-variant-names > span').forEach(label => {
        if (label.textContent.trim() === 'Pack') label.hidden = true;
      });
    }
    queuePriceSync() {
      cancelAnimationFrame(this.priceFrame);
      this.priceFrame = requestAnimationFrame(() => this.syncBundlePrice());
    }
    selectedBar() {
      return this.bundleAnchor.querySelector('input[type="radio"]:checked')?.closest('.kaching-bundles__bar') || this.bundleAnchor.querySelector('.kaching-bundles__bar--selected');
    }
    syncBundleVariant() {
      if (!this.current) return;
      const id = String(this.current.id);
      this.bundleAnchor.querySelectorAll('kaching-bundles-block').forEach(widget => {
        if (widget.getAttribute('current-variant-id') !== id) widget.setAttribute('current-variant-id',id);
      });
    }
    parseMoney(text) {
      const locale = document.documentElement.lang || 'en-US';
      const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
      const decimal = parts.find(part => part.type === 'decimal')?.value || '.';
      const group = parts.find(part => part.type === 'group')?.value;
      let value = text.replace(/[^0-9.,\u066B\u066C-]/g,'');
      if (group) value = value.split(group).join('');
      value = value.replace(decimal,'.');
      return Number(value);
    }
    syncBundlePrice() {
      if (!this.current) return;
      const selected = this.selectedBar();
      const priceText = selected?.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
      const quantity = Number(this.offerQuantities.get(selected?.dataset.dealBarId));
      const amount = priceText ? this.parseMoney(priceText) : NaN;
      if (selected && priceText && Number.isFinite(amount) && quantity > 0) {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.data.currency});
        this.price.textContent = formatter.format(Math.round((amount / quantity + Number.EPSILON) * 100) / 100);
        this.unit.textContent = this.data.labels.perPair;
        this.total.textContent = this.data.labels.bundleTotal.replace('[total]',formatter.format(amount)).replace('[count]',quantity).replace('[pairs]',quantity === 1 ? this.data.labels.pair : this.data.labels.pairs);
        this.total.hidden = false;
      } else if (selected && priceText) {
        this.price.textContent = priceText;
        this.unit.textContent = this.data.labels.total;
        this.total.hidden = true;
      } else {
        this.price.textContent = this.current.money;
        this.unit.textContent = this.data.labels.perPair;
        this.total.hidden = true;
      }
      const pickerValues = name => [...new Set(Array.from(selected?.querySelectorAll(`select[data-name="${name}"]`) || []).map(select => select.value))];
      const sizes = pickerValues('Size');
      const colors = pickerValues('Color');
      const selection = sizes.length || colors.length ? [sizes.join(' / '),colors.join(' + ')].filter(Boolean).join(' · ') : this.current.options.slice(1).join(' · ');
      this.querySelector('[data-sticky-unit]').textContent = [this.price.textContent + ' ' + this.unit.textContent,selection].join(' · ');
    }
    syncGallerySelection() {
      const hero = this.querySelector('[data-hero-image]');
      const path = new URL(hero.src,location.href).pathname;
      this.querySelectorAll('[data-gallery-image]').forEach(button => button.setAttribute('aria-pressed',String(new URL(button.dataset.galleryImage,location.href).pathname === path)));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.bundleObserver?.disconnect();
      clearTimeout(this.bundleTimeout);
      cancelAnimationFrame(this.priceFrame);
    }
    updateBuyState() {
      const available = Boolean(this.current?.available);
      const pending = this.add.closest('product-form')?.hasAttribute('data-cart-pending');
      this.add.disabled = pending || !available || !this.bundleReady;
      this.querySelector('[data-add-label]').textContent = pending ? this.data.labels.adding : !available ? this.data.labels.soldOut : this.bundleReady ? this.data.labels.add : this.data.labels.loadingOffers;
    }
    update(updateUrl) {
      const options = this.data.optionNames.map((_,index) => index === 0 ? '1 pair' : this.querySelector(`[data-option-index="${index}"]:checked`)?.value);
      this.current = this.variants.find(variant => variant.options.every((value,index) => value === options[index]));
      const variant = this.current;
      this.select.value = variant ? String(variant.id) : '';
      this.syncBundleVariant();
      this.querySelector('[data-shipping-note]').textContent = this.dataset.country === 'US' ? this.data.labels.shippingThreshold : this.data.labels.checkoutShipping;
      this.querySelector('[data-sticky-title]').textContent = this.data.title;
      this.stickyAdd.textContent = this.data.labels.chooseOffer;
      if (variant) this.syncBundlePrice();
      else {
        this.price.textContent = '—';
        this.total.hidden = true;
      }
      this.updateBuyState();
      if (variant && updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant',variant.id);
        window.history.replaceState({},'',url);
        this.select.dispatchEvent(new Event('change',{bubbles:true}));
        this.queuePriceSync();
      }
      if (variant?.image && updateUrl) {
        const hero = this.querySelector('[data-hero-image]');
        hero.src = variant.image;
        hero.srcset = '';
        hero.alt = variant.imageAlt || this.data.title;
        this.syncGallerySelection();
      }
    }
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
}


